module.exports = __webpack_public_path__ + "img/title4.7fc44b8f.jpg";